import { Spin } from "antd";

export const Loading = () => {
  return (
    <div className="flex-center pd15">
      <Spin tip="Đang tải dữ liệu" />
    </div>
  );
};
